import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { kubernetesTranslationRef } from '@backstage/plugin-kubernetes';

export const kubernetesTranslations = createTranslationResource({
  ref: kubernetesTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
  },
});
